import { __extends } from 'tslib';
import { ChangeDetectionStrategy, Component, Input, HostBinding, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

var Defaults = {
    PrimaryColor: '#f3f3f3',
    SecondaryColor: '#ecebeb',
    PreserveAspectRatio: 'xMidYMid meet',
    Classes: '',
    Speed: '1000ms',
    Width: '400',
    Height: '130',
    Rx: '0',
    Ry: '1',
};
var NgxContentLoadingComponent = /** @class */ (function () {
    function NgxContentLoadingComponent() {
        this.width = Defaults.Width;
        this.height = Defaults.Height;
        this.primaryColor = Defaults.PrimaryColor;
        this.secondaryColor = Defaults.SecondaryColor;
        this.speed = Defaults.Speed;
        this.preserveAspectRatio = Defaults.PreserveAspectRatio;
    }
    Object.defineProperty(NgxContentLoadingComponent.prototype, "viewBox", {
        get: function () {
            return "0 0 " + this.width + " " + this.height;
        },
        enumerable: true,
        configurable: true
    });
    NgxContentLoadingComponent.prototype.ngOnInit = function () { };
    return NgxContentLoadingComponent;
}());
NgxContentLoadingComponent.decorators = [
    { type: Component, args: [{
                selector: 'ngx-content-loading',
                template: "<ng-content select=\"[before-svg]\"></ng-content>\n<svg version=\"1.1\"\n    [attr.preserveAspectRatio]=\"preserveAspectRatio\"\n    [attr.viewBox]=\"viewBox\">\n        <ng-content></ng-content>\n</svg>\n<ng-content select=\"[after-svg]\"></ng-content>\n",
                styles: [""],
                changeDetection: ChangeDetectionStrategy.OnPush
            },] },
];
NgxContentLoadingComponent.ctorParameters = function () { return []; };
NgxContentLoadingComponent.propDecorators = {
    "width": [{ type: Input },],
    "height": [{ type: Input },],
    "primaryColor": [{ type: Input },],
    "secondaryColor": [{ type: Input },],
    "speed": [{ type: Input },],
    "preserveAspectRatio": [{ type: Input },],
};
var SvgElementComponent = /** @class */ (function () {
    function SvgElementComponent(content) {
        this.content = content;
        this.clipPathId = getId();
        this.linearGradientId = getId();
    }
    Object.defineProperty(SvgElementComponent.prototype, "clipPathUrl", {
        get: function () {
            return "url(#" + this.clipPathId + ")";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SvgElementComponent.prototype, "linearGradientUrl", {
        get: function () {
            return "url(#" + this.linearGradientId + ")";
        },
        enumerable: true,
        configurable: true
    });
    SvgElementComponent.prototype.ngOnInit = function () {
    };
    return SvgElementComponent;
}());
SvgElementComponent.decorators = [
    { type: Component, args: [{
                selector: 'ngx-svg-element',
                template: "",
                styles: [""],
                changeDetection: ChangeDetectionStrategy.OnPush
            },] },
];
SvgElementComponent.ctorParameters = function () { return [
    { type: NgxContentLoadingComponent, },
]; };
function getId() {
    var id = performance.now() * Math.random();
    return id.toString();
}
var RectComponent = /** @class */ (function (_super) {
    __extends(RectComponent, _super);
    function RectComponent(content) {
        var _this = _super.call(this, content) || this;
        _this.content = content;
        _this.rx = Defaults.Rx;
        _this.ry = Defaults.Ry;
        return _this;
    }
    return RectComponent;
}(SvgElementComponent));
RectComponent.decorators = [
    { type: Component, args: [{
                selector: '[ngx-rect]',
                template: "<svg:rect\n        [attr.x]=\"x\"\n        [attr.y]=\"y\"\n        [attr.rx]=\"rx\"\n        [attr.ry]=\"ry\"\n        [attr.width]=\"width\"\n        [attr.fill]=\"linearGradientUrl\"\n        [attr.clipPath]=\"clipPathUrl\"\n        [attr.height]=\"height\">\n</svg:rect>\n<svg:defs>\n    <svg:clipPath [attr.id]=\"clipPathId\"></svg:clipPath>\n    <svg:linearGradient [attr.id]=\"linearGradientId\">\n        <svg:stop ngx-svg-stop\n            [offset]=\"'0%'\"\n            [values]=\"'-2; 1'\"\n            [speed]=\"content.speed\"\n            [color]=\"content.primaryColor\">\n        </svg:stop>\n        <svg:stop ngx-svg-stop\n            [offset]=\"'50%'\"\n            [values]=\"'-1.5; 1.5'\"\n            [speed]=\"content.speed\"\n            [color]=\"content.secondaryColor\">\n        </svg:stop>\n        <svg:stop ngx-svg-stop\n            [offset]=\"'100%'\"\n            [values]=\"'-1; 2'\"\n            [speed]=\"content.speed\"\n            [color]=\"content.primaryColor\">\n        </svg:stop>\n    </svg:linearGradient>\n</svg:defs>\n",
                styles: [""]
            },] },
];
RectComponent.ctorParameters = function () { return [
    { type: NgxContentLoadingComponent, },
]; };
RectComponent.propDecorators = {
    "y": [{ type: Input },],
    "x": [{ type: Input },],
    "rx": [{ type: Input },],
    "ry": [{ type: Input },],
    "width": [{ type: Input },],
    "height": [{ type: Input },],
    "primaryColor": [{ type: Input },],
    "secondaryColor": [{ type: Input },],
    "speed": [{ type: Input },],
};
var SvgStopComponent = /** @class */ (function () {
    function SvgStopComponent() {
    }
    SvgStopComponent.prototype.ngOnInit = function () {
    };
    return SvgStopComponent;
}());
SvgStopComponent.decorators = [
    { type: Component, args: [{
                selector: '[ngx-svg-stop]',
                template: "<svg:animate\n    attributeName=\"offset\"\n    [attr.values]=\"values\"\n    [attr.dur]=\"speed\"\n    repeatCount=\"indefinite\"\n/>\n",
                styles: [""],
                changeDetection: ChangeDetectionStrategy.OnPush
            },] },
];
SvgStopComponent.ctorParameters = function () { return []; };
SvgStopComponent.propDecorators = {
    "speed": [{ type: Input },],
    "values": [{ type: Input },],
    "offset": [{ type: HostBinding, args: ['attr.offset',] }, { type: Input },],
    "color": [{ type: HostBinding, args: ['attr.stop-color',] }, { type: Input },],
};
var FacebookPresetComponent = /** @class */ (function () {
    function FacebookPresetComponent() {
    }
    FacebookPresetComponent.prototype.ngOnInit = function () {
    };
    return FacebookPresetComponent;
}());
FacebookPresetComponent.decorators = [
    { type: Component, args: [{
                selector: '[ngx-facebook-preset]',
                template: "<svg:g ngx-circle cx=\"25\" cy=\"25\" r=\"25\"></svg:g>\n<svg:g ngx-rect width=\"100\" height=\"5\" y=\"15\" x=\"60\" rx=\"5\" ry=\"5\"></svg:g>\n<svg:g ngx-rect width=\"60\" height=\"5\" y=\"30\" x=\"60\" rx=\"5\" ry=\"5\"></svg:g>\n<svg:g ngx-rect width=\"170\" height=\"5\" y=\"65\" x=\"0\" rx=\"5\" ry=\"5\"></svg:g>\n<svg:g ngx-rect width=\"220\" height=\"5\" y=\"80\" x=\"0\" rx=\"5\" ry=\"5\"></svg:g>\n<svg:g ngx-rect width=\"130\" height=\"5\" y=\"95\" x=\"0\" rx=\"5\" ry=\"5\"></svg:g>\n",
                styles: [""],
                changeDetection: ChangeDetectionStrategy.OnPush
            },] },
];
FacebookPresetComponent.ctorParameters = function () { return []; };
var InstagramPresetComponent = /** @class */ (function () {
    function InstagramPresetComponent() {
    }
    InstagramPresetComponent.prototype.ngOnInit = function () {
    };
    return InstagramPresetComponent;
}());
InstagramPresetComponent.decorators = [
    { type: Component, args: [{
                selector: '[ngx-instagram-preset]',
                template: "<svg:g ngx-circle cx=\"25\" cy=\"25\" r=\"25\"></svg:g>\n<svg:g ngx-rect width=\"120\" height=\"10\" y=\"10\" x=\"60\" rx=\"5\" ry=\"5\"></svg:g>\n<svg:g ngx-rect width=\"40\" height=\"5\" y=\"30\" x=\"60\" rx=\"5\" ry=\"5\"></svg:g>\n<svg:g ngx-rect width=\"250\" height=\"250\" y=\"60\" x=\"0\" rx=\"5\" ry=\"5\"></svg:g>\n",
                styles: [""],
                changeDetection: ChangeDetectionStrategy.OnPush
            },] },
];
InstagramPresetComponent.ctorParameters = function () { return []; };
var CircleComponent = /** @class */ (function (_super) {
    __extends(CircleComponent, _super);
    function CircleComponent(content) {
        var _this = _super.call(this, content) || this;
        _this.content = content;
        return _this;
    }
    return CircleComponent;
}(SvgElementComponent));
CircleComponent.decorators = [
    { type: Component, args: [{
                selector: '[ngx-circle]',
                template: "<svg:circle\n        [attr.cx]=\"cx\"\n        [attr.cy]=\"cy\"\n        [attr.r]=\"r\"\n        [attr.fill]=\"linearGradientUrl\"\n        [attr.clipPath]=\"clipPathUrl\">\n</svg:circle>\n<svg:defs>\n    <svg:clipPath [attr.id]=\"clipPathId\"></svg:clipPath>\n    <svg:linearGradient [attr.id]=\"linearGradientId\">\n        <svg:stop ngx-svg-stop\n            [offset]=\"'0%'\"\n            [values]=\"'-2; 1'\"\n            [speed]=\"content.speed\"\n            [color]=\"content.primaryColor\">\n        </svg:stop>\n        <svg:stop ngx-svg-stop\n            [offset]=\"'50%'\"\n            [values]=\"'-1.5; 1.5'\"\n            [speed]=\"content.speed\"\n            [color]=\"content.secondaryColor\">\n        </svg:stop>\n        <svg:stop ngx-svg-stop\n            [offset]=\"'100%'\"\n            [values]=\"'-1; 2'\"\n            [speed]=\"content.speed\"\n            [color]=\"content.primaryColor\">\n        </svg:stop>\n    </svg:linearGradient>\n</svg:defs>\n",
                styles: [""]
            },] },
];
CircleComponent.ctorParameters = function () { return [
    { type: NgxContentLoadingComponent, },
]; };
CircleComponent.propDecorators = {
    "r": [{ type: Input },],
    "cx": [{ type: Input },],
    "cy": [{ type: Input },],
};
var CodePresetComponent = /** @class */ (function () {
    function CodePresetComponent() {
    }
    CodePresetComponent.prototype.ngOnInit = function () {
    };
    return CodePresetComponent;
}());
CodePresetComponent.decorators = [
    { type: Component, args: [{
                selector: '[ngx-code-preset]',
                template: "<svg:g ngx-rect width=\"60\" height=\"10\" y=\"15\" x=\"0\" rx=\"5\" ry=\"5\"></svg:g>\n<svg:g ngx-rect width=\"90\" height=\"10\" y=\"15\" x=\"70\" rx=\"5\" ry=\"5\"></svg:g>\n<svg:g ngx-rect width=\"20\" height=\"10\" y=\"15\" x=\"170\" rx=\"5\" ry=\"5\"></svg:g>\n<svg:g ngx-rect width=\"100\" height=\"10\" y=\"35\" x=\"9\" rx=\"5\" ry=\"5\"></svg:g>\n<svg:g ngx-rect width=\"120\" height=\"10\" y=\"35\" x=\"120\" rx=\"5\" ry=\"5\"></svg:g>\n<svg:g ngx-rect width=\"90\" height=\"10\" y=\"55\" x=\"5\" rx=\"5\" ry=\"5\"></svg:g>\n<svg:g ngx-rect width=\"90\" height=\"10\" y=\"55\" x=\"105\" rx=\"5\" ry=\"5\"></svg:g>\n<svg:g ngx-rect width=\"70\" height=\"10\" y=\"55\" x=\"205\" rx=\"5\" ry=\"5\"></svg:g>\n<svg:g ngx-rect width=\"30\" height=\"10\" y=\"75\" x=\"0\" rx=\"5\" ry=\"5\"></svg:g>\n",
                changeDetection: ChangeDetectionStrategy.OnPush
            },] },
];
CodePresetComponent.ctorParameters = function () { return []; };
var BulletListPresetComponent = /** @class */ (function () {
    function BulletListPresetComponent() {
    }
    BulletListPresetComponent.prototype.ngOnInit = function () {
    };
    return BulletListPresetComponent;
}());
BulletListPresetComponent.decorators = [
    { type: Component, args: [{
                selector: '[ngx-bullet-list-preset]',
                template: "<svg:g ngx-circle cx=\"7\" cy=\"7\" r=\"7\"></svg:g>\n<svg:g ngx-circle cx=\"7\" cy=\"37\" r=\"7\"></svg:g>\n<svg:g ngx-circle cx=\"7\" cy=\"67\" r=\"7\"></svg:g>\n<svg:g ngx-circle cx=\"7\" cy=\"97\" r=\"7\"></svg:g>\n<svg:g ngx-rect width=\"200\" height=\"12\" y=\"2\" x=\"20\" rx=\"5\" ry=\"5\"></svg:g>\n<svg:g ngx-rect width=\"200\" height=\"12\" y=\"32\" x=\"20\" rx=\"5\" ry=\"5\"></svg:g>\n<svg:g ngx-rect width=\"200\" height=\"12\" y=\"62\" x=\"20\" rx=\"5\" ry=\"5\"></svg:g>\n<svg:g ngx-rect width=\"200\" height=\"12\" y=\"92\" x=\"20\" rx=\"5\" ry=\"5\"></svg:g>\n",
                changeDetection: ChangeDetectionStrategy.OnPush
            },] },
];
BulletListPresetComponent.ctorParameters = function () { return []; };
var ListPresetComponent = /** @class */ (function () {
    function ListPresetComponent() {
    }
    ListPresetComponent.prototype.ngOnInit = function () {
    };
    return ListPresetComponent;
}());
ListPresetComponent.decorators = [
    { type: Component, args: [{
                selector: '[ngx-list-preset]',
                template: "<svg:g ngx-rect width=\"200\" height=\"10\" y=\"0\" x=\"0\" rx=\"5\" ry=\"5\"></svg:g>\n<svg:g ngx-rect width=\"180\" height=\"10\" y=\"20\" x=\"20\" rx=\"5\" ry=\"5\"></svg:g>\n<svg:g ngx-rect width=\"160\" height=\"10\" y=\"40\" x=\"20\" rx=\"5\" ry=\"5\"></svg:g>\n<svg:g ngx-rect width=\"200\" height=\"10\" y=\"60\" x=\"0\" rx=\"5\" ry=\"5\"></svg:g>\n<svg:g ngx-rect width=\"180\" height=\"10\" y=\"80\" x=\"20\" rx=\"5\" ry=\"5\"></svg:g>\n<svg:g ngx-rect width=\"60\" height=\"10\" y=\"100\" x=\"20\" rx=\"5\" ry=\"5\"></svg:g>\n",
                changeDetection: ChangeDetectionStrategy.OnPush
            },] },
];
ListPresetComponent.ctorParameters = function () { return []; };
var NgxContentLoadingModule = /** @class */ (function () {
    function NgxContentLoadingModule() {
    }
    return NgxContentLoadingModule;
}());
NgxContentLoadingModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    CommonModule
                ],
                declarations: [
                    NgxContentLoadingComponent,
                    RectComponent,
                    CircleComponent,
                    SvgElementComponent,
                    SvgStopComponent,
                    FacebookPresetComponent,
                    InstagramPresetComponent,
                    CodePresetComponent,
                    BulletListPresetComponent,
                    ListPresetComponent
                ],
                exports: [
                    NgxContentLoadingComponent,
                    RectComponent,
                    CircleComponent,
                    FacebookPresetComponent,
                    InstagramPresetComponent,
                    CodePresetComponent,
                    BulletListPresetComponent,
                    ListPresetComponent
                ]
            },] },
];
NgxContentLoadingModule.ctorParameters = function () { return []; };

export { NgxContentLoadingModule, BulletListPresetComponent as ɵi, CircleComponent as ɵd, CodePresetComponent as ɵh, FacebookPresetComponent as ɵf, InstagramPresetComponent as ɵg, ListPresetComponent as ɵj, NgxContentLoadingComponent as ɵa, RectComponent as ɵb, SvgElementComponent as ɵc, SvgStopComponent as ɵe };
//# sourceMappingURL=ngx-content-loading.js.map
